import CategoryModule from '@modules/Category';
import ParallaxModule from '@modules/Parallax';
import SmsEcap from '@utils/smsEcap';
import Care from '@modules/Care';
import loadTradeform from '@modules/tradeForm';
import loadLargeOrderForm from '@modules/largeOrderForm';
import RewardsTableSlider from '@modules/rewardsTableSlider';
import '../../style/templates/page.scss';
import '../../style/config/yotpo-widgets.scss';
import { pubSub } from '@utils/PubSub';
import { SwymResults } from '@components/SwymResults';
import '@modules/DuoShop';

function displayUA(uaRes) {
  const uaDisplay = document.querySelector('#uaDisplay');
  const uaJSON = JSON.stringify(uaRes, null, 2);
  uaDisplay.innerHTML = uaJSON;
  uaDisplay.style.height = uaDisplay.scrollHeight + 'px';
}

function copyUa() {
  const uaDisplay = document.querySelector('#uaDisplay');
  const uaCta = document.querySelector('#uaCta');
  uaDisplay.select();
  document.execCommand('copy');
  uaCta.innerHTML = 'Copied!';
}

function resetUaCta() {
  setTimeout(() => {
    document.querySelector('#uaCta').innerHTML = 'Copy to Clipboard';
  }, 1000);
}

const triggerChat = async () => {
  const template = document.body;
  const isVariant = template.classList.contains('js-siena-enabled');

  try {
    if (isVariant) {
      window.SienaLaunchWidget();
    } else {
      window.Gladly.show();
    }
  } catch (error) {
    throw new Error(`Chat failed to load: ${error}`);
  }
};

/**
 * Sets up the rewards header story module based on the Yotpo hero widget.
 * Runs once .yotpo-widget-hero-section is present in the DOM.
 */

const initRewardsHeader = () => {
  const yotpoHero = document.querySelector('.yotpo-widget-hero-section'),
    rewardsHeader = document.querySelector('.rewards__header'),
    storyModule = rewardsHeader.querySelector('.story'),
    storyHeadline = rewardsHeader.querySelector('.story__headline'),
    storySubheader = rewardsHeader.querySelector('.story__subhead'),
    customerName = storyModule.dataset.customerName;

  const memberSubheader =
    'Work and daily life are exhausting—finding comfort shouldn&apos;t be. So sit back, relax, and earn more while you shop.';
  const guestSubheader =
    'When you become a Brooklinen Rewards member you can earn points for every dollar spent, get free shipping <a class="link" href="https://www.brooklinen.com/pages/faq?a=Does-Brooklinen-offer-free-US-shipping---id--1b50Cl_wSuiEqf4NUNMMOQ" target="_blank">see terms</a>, exclusive access to events, sales and more...';
  const welcomeText = 'Welcome to the Crew';

  const updateStoryModuleContent = () => {
    if (customerName !== '') {
      storyHeadline.innerHTML = `${welcomeText}, ${customerName}!`;
      storySubheader.innerHTML = memberSubheader;
      storyHeadline.innerHTML = storyHeadline.innerHTML.replace(
        '{{first_name}}',
        customerName
      );
    } else {
      storyHeadline.innerHTML = `${welcomeText}!`;
      storySubheader.innerHTML = guestSubheader;
    }
  };

  // Sets up story module based on yotpo banner section widget
  if (yotpoHero && rewardsHeader) {
    const yotpoTitle = yotpoHero.querySelector('.yotpo-title');
    if (yotpoTitle) storyHeadline.innerHTML = yotpoTitle.innerHTML;

    updateStoryModuleContent();

    const yotpoImg = yotpoHero.querySelector('.yotpo-text-on-background').style
        .backgroundImage,
      yotpoImgSrc = yotpoImg.slice(4, -1).replace(/["']/g, '');
    if (yotpoImgSrc)
      rewardsHeader.querySelector('.story__media-img').src = yotpoImgSrc;

    storyModule.dataset.content = 'widget';
  } else {
    // Fallback, depending on customer login state
    updateStoryModuleContent();

    storyModule.dataset.content = 'fallback';
  }

  // Customer points & tier details
  const email = document.querySelector('[data-customer]')?.dataset.customer;
  if (email) {
    const pageCurrentPoints = window.Brooklinen.loyalty?.points_balance;
    const pageTier = window.Brooklinen.loyalty?.vip_tier_name;
    const pageTierText = pageTier
      ? ` <span class="t4" data-color="afternoon-delight-medium">${pageTier}</span> `
      : '';

    // Yotpo controlled text
    if (storySubheader.innerHTML.includes('{{current_point_balance}}')) {
      storySubheader.innerHTML = storySubheader.innerHTML
        .replace('{{current_vip_tier_name}}', pageTierText)
        .replace(
          '{{current_point_balance}}',
          `<span class="t4" data-color="afternoon-delight-medium">${pageCurrentPoints}</span>`
        )
        .replace("You're currently a", "<br/> <br/> You're currently a");
    } else {
      // Fallback
      storySubheader.innerHTML += `<br/> <br/> You're currently a ${pageTierText} member with <span class="t4" data-color="afternoon-delight-medium">${pageCurrentPoints}</span> points.`;
    }
  }

  storyModule.classList.remove('hidden');
  rewardsHeader.querySelector('.Stencil').classList.add('hidden');
  document.querySelector('.rewards__widgets').classList.remove('hidden');
};

document.addEventListener('DOMContentLoaded', () => {
  pubSub.broadcast();
  new SwymResults();

  const categoryModule = document.querySelectorAll('.js-category-module');
  categoryModule.forEach((module) => new CategoryModule(module));

  const parallaxModule = document.querySelectorAll('.js-parallax-module');
  parallaxModule.forEach((module) => new ParallaxModule(module));

  const careModule = document.querySelectorAll('.js-care-module');
  careModule.forEach((module) => new Care(module));

  const smsEcapModule = document.querySelectorAll('.js-sms-ecap-module');
  smsEcapModule.forEach((module) => new SmsEcap(module));

  // Drawer can be dropped on any page, so key off the DOM not the url
  loadLargeOrderForm();

  // Load trade form and rewards modules on their respective page url
  if (window.location.pathname.includes('trade')) loadTradeform();
  else if (window.location.pathname.includes('pages/rewards')) {
    if (document.querySelector('.yotpo-widget-hero-section')) {
      initRewardsHeader();
    } else {
      const observer = new MutationObserver(() => {
        if (
          document.querySelector('.yotpo-widget-hero-section') &&
          document.querySelector('.yotpo-title')
        ) {
          observer.disconnect();
          initRewardsHeader();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Rewards Tier Table Slider
    const tierSlider = document.querySelector('.tier-compare-mobile');
    new RewardsTableSlider(tierSlider);
  } else if (window.location.pathname.includes('pages/cart-support')) {
    setTimeout(() => triggerChat(), 0);
    document
      .querySelector('.themeHero .button--primary-inverse')
      .addEventListener('click', (e) => {
        e.preventDefault();
        setTimeout(() => triggerChat(), 0);
      });

    document
      .querySelector('.primaryHero .button--primary')
      .addEventListener('click', (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:request'));
      });
  }

  // Load user agent logic
  if (document.querySelector('.module--ua')) {
    const parser = new UAParser(); //eslint-disable-line no-undef
    const uaRes = parser.getResult();
    delete uaRes.ua;
    delete uaRes.cpu;

    const DYready = setInterval(() => {
      if (typeof window.DY?.Audiences === 'object') {
        uaRes.debug = window.DY.Audiences.getUserAudiences().join();
        uaRes.device = window.DY.deviceInfo;
        displayUA(uaRes);
        clearInterval(DYready);
      }
    }, 100);
    // Stop if over 10 sec
    setTimeout(() => clearInterval(DYready), 10000);

    document.querySelector('#uaCta').addEventListener('mouseup', copyUa);
    document.querySelector('#uaCta').addEventListener('mouseout', resetUaCta);
  }
});
